import { RouteConfig } from ".."

import { AdminSettingsLayout } from "~/layouts/AdminSettingsLayout"
import { AdminLayout } from "~/layouts/AdminLayout"
import { ROUTER_PATHS } from "../constants"
import Products from "~/components/Admin/Settings/Product/Products"
import Coupons from "~/components/Admin/Settings/Coupons/Coupons"
import AutomatedMessagesForm from "~/components/Admin/Settings/automatedMessages/AutomatedMessagesForm"
import InvoicesSettings from "~/components/Admin/Settings/InvoiceSettings/InvoiceSettings"
import PolicyAndRulesForm from "~/components/Admin/Settings/PoliciesAndRulesForm/PolicyAndRulesForm"
import PricesForm from "~/components/Admin/Settings/PricesForm/PricesForm"
import Users from "~/components/Admin/Settings/Users/Users"
import Sites from "~/components/Admin/Settings/Sites/Sites"
import ReservationImport from "~/components/Admin/Settings/ReservationImport/ReservationImport"
import CamperImport from "~/components/Admin/Settings/CamperImport/CamperImport"
import EditCampForm from "~/components/Admin/Settings/EditCampForm/EditCampForm"
import StoreContent from "~/components/Admin/Store/StoreContent"
import { AdminGuestsLayout } from "~/layouts/AdminGuestsLayout"
import Campers from "~/components/Admin/Campers/Campers"
import { AdminStoreLayout } from "~/layouts/AdminStoreLayout"
import { AdminTodosLayout } from "~/layouts/AdminTodosLayout"
import ToDos from "~/components/ToDos/ToDos"
import eAdminUserRole from "~/enums/eAdminUserRole"

export const adminRoutes: RouteConfig[] = [
  {
    path: ROUTER_PATHS.ADMIN,
    layout: <AdminLayout />,
    routes: [
      {
        layout: <AdminTodosLayout />,
        path: ROUTER_PATHS.ADMIN_TODOS,
        routes: [
          {
            path: ROUTER_PATHS.ADMIN_TODOS,
            component: <ToDos />,
          },
        ],
      },
      {
        layout: <AdminGuestsLayout />,
        path: ROUTER_PATHS.ADMIN_GUESTS,
        routes: [
          {
            path: ROUTER_PATHS.ADMIN_GUESTS,
            component: <Campers />,
          },
          {
            path: ROUTER_PATHS.ADMIN_GUESTS_GUEST,
            component: <Campers />,
          },
        ],
      },
      {
        layout: <AdminStoreLayout />,
        path: ROUTER_PATHS.ADMIN_STORE,
        routes: [
          {
            path: ROUTER_PATHS.ADMIN_STORE_POS,
            component: <StoreContent />,
          },
          {
            path: ROUTER_PATHS.ADMIN_STORE_HISTORY,
            component: <StoreContent />,
          },
        ],
      },
      {
        layout: <AdminSettingsLayout />,
        path: ROUTER_PATHS.ADMIN_SETTINGS,
        roles: [eAdminUserRole.Admin, eAdminUserRole.ParkAdmin],
        routes: [
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_CAMP_INFO,
            component: <EditCampForm />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_PRICES,
            component: <PricesForm />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_PRODUCTS,
            component: <Products />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_INVOICES,
            component: <InvoicesSettings />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_COUPONS,
            component: <Coupons />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_AUTOMATED_MESSAGES,
            component: <AutomatedMessagesForm />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_RULES_TERMS,
            component: <PolicyAndRulesForm />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_USERS,
            component: <Users />,
            roles: [eAdminUserRole.Admin, eAdminUserRole.ParkAdmin],
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_SITES,
            component: <Sites />,
            roles: [eAdminUserRole.ParkAdmin],
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_RESERVATION_IMPORT,
            component: <ReservationImport />,
            roles: [eAdminUserRole.ParkAdmin],
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_CAMPER_IMPORT,
            component: <CamperImport />,
          },
        ],
      },
    ],
  },
]
